/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import "../style.scss";
import React, { useState, useEffect } from "react";
import {
  message,
  Spin,
  Card,
} from "antd";
import TableContainer from "../../../components/TableContainer";
import axios from "axios";
import urls from "../../../api/urls";
const { HUBS_LIST } = urls;

const HubsList = () => {
  const [hubs, setHubs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchHubs = async (page = 1, limit = 10) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${HUBS_LIST}?page=${page}&limit=${limit}`
      );
      if (response?.data?.status === 200) {
        setHubs(response?.data?.data || []);
        setPagination({
          ...pagination,
          current: page,
          total: response?.data?.count || 0,
        });
      } else {
        message.error("Failed to fetch hubs");
      }
    } catch (error) {
      message.error("Error fetching hubs");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHubs(pagination.current, pagination.pageSize);
  }, [pagination.current, pagination.pageSize]);

  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
    fetchHubs(newPagination.current, newPagination.pageSize);
  };

  const columns = [
    {
      key: "serialNumber",
      title: "S.No",
      render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
      fixed: 'left',
    },
    {
      key: "hubName",
      title: "Hub Name",
      dataIndex: "hubName",
      width: 250,
    },
    {
      key: "premiseId",
      title: "Premise Id",
      dataIndex: "premiseId",
      width: 100,
    },
    {
      key: "pincode",
      title: "Hub Pincode",
      dataIndex: "pincode",
      width: 120,
    },
  ];

  return (
    <div className="master-main-container m-1 mt-3 p-1">
      <Card title="Hubs List" style={{ marginBottom: "24px" }}>
        <Spin spinning={loading}>
          <TableContainer 
            columns={columns} 
            dataSource={hubs} 
            pagination={pagination}
            onChange={handleTableChange}
          />
        </Spin>
      </Card>
    </div>
  );
};

export default HubsList;
